import { HighlightTextHeadline as HighlightTextHeadline$1 } from '@cbhq/cdx-components';
import { jsx } from 'react/jsx-runtime';
const HIGHLIGHT_TEXT_HEADLINE_CONTENT_MODEL_ID = 'cdxHighlightTextHeadline';
function HighlightTextHeadline({
  headline,
  subhead,
  hasSpacingTop,
  anchor,
  style
}) {
  return /*#__PURE__*/jsx(HighlightTextHeadline$1, {
    headline: headline,
    subhead: subhead,
    anchor: anchor,
    style: style,
    hasSpacingVertical: true,
    hasSpacingTop: hasSpacingTop
  });
}
export { HIGHLIGHT_TEXT_HEADLINE_CONTENT_MODEL_ID, HighlightTextHeadline };
//# sourceMappingURL=HighlightTextHeadline.js.map
